import React, { FC, ReactNode } from 'react';
import Button from 'src/common/components/ButtonDS22';
import { useTranslation } from 'next-i18next';
import { useTripCartContext } from 'src/trip-cart-deprecated/hooks/useTripCartContext';
import { TRIP_CART_PANEL_PRICE_DETAILS } from 'src/listing/constants';
import PriceInfo from 'src/trip-cart-deprecated/components/drawer/PriceInfo';
import styles from './TripCartContentFooter.module.scss';

export type Props = {
  children: ReactNode;
};

const TripCartContentFooter: FC<Props> = ({
  children,
}) => {
  const [t] = useTranslation('listing-page');
  const { showPanel } = useTripCartContext();
  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <PriceInfo />
        <div>
          <Button
            variant="tertiary-deemphasized"
            size="small"
            icon="caret-right"
            iconPosition="right"
            fitWidth="m"
            withTextUnderline={false}
            onClick={() => showPanel(TRIP_CART_PANEL_PRICE_DETAILS)}
          >
            {t('trip-cart--drawer-footer--price-details')}
          </Button>
        </div>
      </div>
      {children}
    </div>
  );
};

export default TripCartContentFooter;
